import { lazy } from 'react';

export * from './model/popup.types';
export * from './model/popup.actions';
export * from './model/popup.store';

export const PopupModal = lazy(() => import('./ui/popup-modal/popup-modal'));